// contexts/ModalProvider.tsx
import React, { type ReactNode, useCallback, useState } from 'react';
import { ModalContext } from './ModalContext';

export const ModalProvider = ({ children }: { children: ReactNode }) => {
    const [modalElement, setModalElement] = useState<ReactNode>(null);

    const openModal = useCallback((element: ReactNode) => {
        setModalElement(element);
    }, []);

    const closeModal = useCallback(() => {
        setModalElement(null);
    }, []);

    return (
        <ModalContext.Provider value={{ openModal, closeModal }}>
            {children}
            {modalElement}
        </ModalContext.Provider>
    );
};
